import Actions from "./Actions";

export const getSettingsData = () => {
  return {
    type: Actions.GET_SETTINGS_DATA,
  };
};
